import { render, staticRenderFns } from "./index-new-product.vue?vue&type=template&id=c350a42a&scoped=true&ref=businessList&"
import script from "./index-new-product.vue?vue&type=script&lang=js&"
export * from "./index-new-product.vue?vue&type=script&lang=js&"
import style0 from "./index-new-product.vue?vue&type=style&index=0&id=c350a42a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c350a42a",
  null
  
)

export default component.exports